
import React, { Component } from 'react';
import styled from 'styled-components';
import ErrorTile, { NoDataTile } from 'components/molecules/ErrorTile';
import loadingGif from 'assets/loading.gif';


const RenderTile = styled(ErrorTile).attrs(() => ({
    iconSrc: loadingGif,
    iconAlt: 'Loading ...'
}))`
    height: ${props => props.height || '100%'};
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    h3 {
        display: none;
    }
    img {
        margin-bottom: 0;
    }
`;


class RenderingTile extends Component {
    render() {
        if (this.props.show === false) {
            return null;
        }

        // check for different states
        switch (this.props.show) {
        case 'NO_CHART_DATA':
            return (
                <NoDataTile height={this.props.height} title={this.props.title} />
            );
        default:
            return (
                <RenderTile height={this.props.height} />
            );
        }
    }
}

export default RenderingTile;



// WEBPACK FOOTER //
// ./src/components/molecules/RenderingTile.js